import ClienteDbQueries from "../repositories/ClienteDbQueries";
import OrdineDbQueries from "../repositories/OrdineDbQueries";
import PiattoDbQueries from "../repositories/PiattoDbQueries";
import RistoranteDbQueries from "../repositories/RistoranteDbQueries";
import TavoloDbQueries from "../repositories/TavoloDbQueries";
import NotifierService from "./NotifierService";
import { OrdineService } from "./OrdineService";
import PiattoService from "./PiattoService";
import { RistoranteService } from "./RistoranteService";
import TavoloService from "./TavoloService";
import { ArticoloService } from "./ArticoloService";
import { SezioneAggiuntivaService } from "./SezioneAggiuntivaService";
import CarrelloService from "./CarrelloService";
import { ClienteService } from "./ClienteService";
import { BusinessIntelligenceService } from "./BusinessIntelligenceService";
import { AiAdviceService } from "./AiAdviceService";
import { TilbyService } from "./TilbyService";
import { CassaincloudService } from "./CassaincloudService";

class ServicesProvider {
    private clienteDbQueries: ClienteDbQueries;
    private ordineDbQueries: OrdineDbQueries;
    private piattoDbQueries: PiattoDbQueries;
    private ristoranteDbQueries: RistoranteDbQueries;
    private tavoloDbQueries: TavoloDbQueries;

    private ordineService: OrdineService;
    private piattoService: PiattoService;
    private ristoranteService: RistoranteService;
    private articoloService: ArticoloService;
    private sezioneAggiuntivaService: SezioneAggiuntivaService;
    private tavoloService: TavoloService;
    private carrelloService: CarrelloService;
    private clienteService: ClienteService;

    private notifierService: NotifierService;
    private businessIntelligenceService: BusinessIntelligenceService;
    private aiAdviceService: AiAdviceService;
    private tilbyService: TilbyService;
    private cassaincloudService: CassaincloudService;

    constructor() {
        this.clienteDbQueries = new ClienteDbQueries();
        this.ordineDbQueries = new OrdineDbQueries();
        this.piattoDbQueries = new PiattoDbQueries();
        this.ristoranteDbQueries = new RistoranteDbQueries();
        this.tavoloDbQueries = new TavoloDbQueries();

        this.ordineService = new OrdineService();
        this.piattoService = new PiattoService();
        this.ristoranteService = new RistoranteService();
        this.articoloService = new ArticoloService();
        this.sezioneAggiuntivaService = new SezioneAggiuntivaService();
        this.tavoloService = new TavoloService();
        this.carrelloService = new CarrelloService();
        this.clienteService = new ClienteService();

        this.notifierService = new NotifierService();

        this.businessIntelligenceService = new BusinessIntelligenceService();
        this.aiAdviceService = new AiAdviceService();
        this.tilbyService = new TilbyService();
        this.cassaincloudService = new CassaincloudService();
    }

    getClienteDbQueries() {
        return this.clienteDbQueries;
    }

    getOrdineDbQueries() {
        return this.ordineDbQueries;
    }

    getPiattoDbQueries() {
        return this.piattoDbQueries;
    }

    getRistoranteDbQueries() {
        return this.ristoranteDbQueries;
    }

    getOrdineService() {
        return this.ordineService;
    }

    getPiattoService() {
        return this.piattoService;
    }

    getRistoranteService() {
        return this.ristoranteService;
    }

    getArticoloService() {
        return this.articoloService;
    }

    getSezioneAggiuntivaService() {
        return this.sezioneAggiuntivaService;
    }

    getNotifierService() {
        return this.notifierService;
    }

    getTavoloDbQueries() {
        return this.tavoloDbQueries;
    }

    getTavoloService() {
        return this.tavoloService;
    }

    getCarrelloService() {
        return this.carrelloService;
    }

    getClienteService() {
        return this.clienteService;
    }

    getBusinessIntelligenceService() {
        return this.businessIntelligenceService;
    }

    getAiAdviceService() {
        return this.aiAdviceService;
    }

    getTilbyService() {
        return this.tilbyService;
    }

    getCassaincloudService() {
        return this.cassaincloudService;
    }
}

let servicesProvider = new ServicesProvider();
export default servicesProvider;